export const level = {
    "100sShort": "100s",
    "200sShort": "200s",
    "300sShort": "300s",
    "400sShort": "400s",
    "500sShort": "500s",
    "600sShort": "600s",
    "700sShort": "700s",
    "800sShort": "800s",
    "900sShort": "900s",
    etcShort: "ETC",
}
